export default __webpack_public_path__ + "static/park-pedregal-amenidades-08-cancha-padel-e4ffb37ee35ca20701f0abfd1bf738a3.jpg";